import type { ReactElement } from 'react';

import type { QuestType, TaskFormController } from './Tasks.types';

export const withQuest = <F, T extends QuestType = 'text', Props = F & TaskFormController<T>>(
  fn: (options: Props) => ReactElement<Props> | null,
) => fn;
